'use client';

import Phone from '@hc-frontend/core-icons/kit/phone';
import type { PhoneCampaign } from '@hc-frontend/core-types';

import { CallCta } from '../../atoms/call-cta';

export function CallCampaignPhoneAndSchedule({
  phoneCampaign,
  sameSize = false,
  showSchedule = false,
}: {
  phoneCampaign: PhoneCampaign;
  sameSize?: boolean;
  showSchedule?: boolean;
}) {
  const { phoneNumber, tty, todayTTY, schedule } = phoneCampaign;
  const phoneNumberAndTty = `${phoneNumber} (${tty})`;

  return (
    <>
      <div className="tablet:hidden">
        <CallCta
          phoneCampaign={phoneCampaign}
          className="hc-typography--heading-three block"
        >
          <Phone data-testid="call-cta-phone" />
        </CallCta>
      </div>
      <div
        className={
          'hc-stack-layout--small hidden tablet:flex' +
          (sameSize ? ' items-start' : 'items-center')
        }
        style={{
          '--hc-stack-layout-space-small': '0rem',
        }}
      >
        <p className="hc-typography--paragraph-sm">
          Call a licensed insurance agent
        </p>
        <div className="flex">
          <a
            href={phoneCampaign.href}
            className={
              'hc-btn--text hc-typography--paragraph-md p-[0] font-bold focus:no-underline ' +
              (sameSize
                ? 'hc-typography--paragraph-sm'
                : 'leading-[calc(var(--font-size-heading-three)*0.85)]')
            }
            data-call-placement={phoneCampaign.placement}
            data-call-product={phoneCampaign.product}
            data-call-phone={phoneCampaign.href}
            data-call-advertiser={phoneCampaign.advertiser}
          >
            {phoneNumberAndTty}
          </a>
        </div>
        <div className="hc-typography--paragraph-sm inline-flex gap-2-4">
          <div className="inline-block max-w-[35ch] overflow-hidden text-gray-400">
            {showSchedule ? `${schedule} ${todayTTY}` : todayTTY}
          </div>
        </div>
      </div>
    </>
  );
}
